/**
 * Menu sub-pages
 */

(() => {

  var hierarchy_toggles = document.querySelectorAll('.js-sub-pages button');
  if (hierarchy_toggles !== null) {
    for (var i = hierarchy_toggles.length - 1; i >= 0; i--) {
      hierarchy_toggles[i].addEventListener('click', (e) => {
        e.currentTarget.parentNode.classList.toggle('active');
        return false;
      });
    }
  }

})();
